import DBG from "./DBG";
import Task from "./Task";
export default class ProjectData {
    // Get the maximum index of the tasks for the current project.
    static getMaxTaskIndex() {
        let res = new Promise((resolve, reject) => {
            Office.context.document.getMaxTaskIndexAsync(function (result) {
                if (result.status === Office.AsyncResultStatus.Failed) {
                    reject(result.error);
                }
                else {
                    resolve(result.value);
                    ProjectData.maxTaskId = result.value;
                }
            });
        });
        return res;
    }
    static addTaskChangedEvent() {
        Office.context.document.addHandlerAsync(Office.EventType.ItemChanged, res => {
            DBG.log("[EVENT] - item changed", res);
        });
        Office.context.document.addHandlerAsync(Office.EventType.TaskSelectionChanged, res => {
            DBG.log("[EVENT] - task selection changed", res);
        });
        Office.context.document.addHandlerAsync(Office.EventType.ViewSelectionChanged, res => {
            DBG.log("[EVENT] - view selection changed", res);
        });
    }
    /*
        static getTaskGuidRec(index, max, onCompleted) {
            Office.context.document.getTaskByIndexAsync(index,
                function (result) {
                    if (result.status === Office.AsyncResultStatus.Succeeded) {
                        DBG.log(`ProjectData - Got task guid: ${index} of ${max} = ${result.value}`);
                        ProjectData.taskIdToGuid[index] = result.value;
    
                        Task.ReadData(result.value).then(t => {
                            DBG.log(t.toString());
                            ProjectData.taskGuidToTask[result.value] = t;
                        });
    
                        if (index < max) {
                            setTimeout(() => {
                                ProjectData.getTaskGuidRec(index + 1, max, onCompleted);
                            }, 10);
                        }
                        if (index == max) {
                            DBG.log("ProjectData - MAX reached");
                            let chartData = [];
    
    
                            setTimeout(() => {
                                for (let i = 0; i <= max; ++i) {
                                    DBG.log("ProjectData - MAX reached - getting task #" + i);
                                    let tsk = ProjectData.taskGuidToTask[ProjectData.taskIdToGuid[i]];
                                    if (tsk.startSector > 0) {
                                        DBG.log(tsk.toString());
                                        chartData.push(tsk);
                                    }
                                }
                                // Make sure Task.ReadData completed for all tasks
                                DBG.log("ProjectData - MAX reached - calling OnCompleted");
                                onCompleted(chartData);
                            }, 100
                            );
    
                        }
    
                    }
                    else {
                        console.log(result.error);
                    }
                }
            );
        }*/
    /*
    public static ReadAllTasks(): Promise<Task[]> {

        let res: Promise<Task[]> = new Promise<Task[]>((resolve, reject) => {
            this.getMaxTaskIndex().then(max => {
                ProjectData.getTaskGuidRec(0, max, chartData => {
                    resolve(chartData);
                });
            });
        });
        return res;
    }
*/
    static ReadAllTasksInQueue(onProgress) {
        let res = new Promise((resolve, reject) => {
            this.getMaxTaskIndex().then(max => {
                DBG.log("ProjectData - ReadAllTasksInQueue", max);
                let queue = [];
                let allTasks = [];
                let cntDone = 0;
                // Step #1 - push all task IDs in queue
                for (let i = 0; i <= max; ++i) {
                    queue.push(i);
                }
                // Step #2 - try to resolve one task every ms. If it fails, put task ID back in queue
                let interval = setInterval(() => {
                    if (queue.length == 0) {
                        return;
                    }
                    let crtId = queue.shift();
                    ProjectData.ReadSingleTask(crtId).then(task => {
                        if (task.startSector > 0) {
                            allTasks.push(task);
                        }
                        DBG.log("ProjectData - ReadAllTasksInQueue - loaded task", crtId, task.guid);
                        cntDone++;
                        if (onProgress) {
                            onProgress(cntDone / (max + 1));
                        }
                        if (cntDone >= max) {
                            resolve(allTasks);
                            clearInterval(interval);
                        }
                    }).catch(reason => {
                        DBG.log("ProjectData - ReadAllTasksInQueue - failed to load task", crtId, reason);
                        queue.push(crtId);
                    });
                }, 1);
            });
        });
        return res;
    }
    static ReadSingleTask(index) {
        let res = new Promise((resolve, reject) => {
            Office.context.document.getTaskByIndexAsync(index, function (result) {
                if (result.status === Office.AsyncResultStatus.Succeeded) {
                    ProjectData.taskIdToGuid[index] = result.value;
                    Task.ReadData(result.value).then(t => {
                        //DBG.log(t.toString());
                        ProjectData.taskGuidToTask[result.value] = t;
                        resolve(t);
                    }).catch(reason => {
                        reject(reason);
                    });
                }
                else {
                    reject(result.error);
                }
            });
        });
        return res;
    }
}
ProjectData.taskIdToGuid = {};
ProjectData.taskGuidToTask = {};
ProjectData.authUser = undefined;
